module.exports = new __parcel__URL__("android-black-chat.8170c98f.svg").toString();